<template>
  <v-dialog v-model="localValue" scrollable width="800" lazy persistent>
    <v-card>
      <v-toolbar color="primary" dense dark>
        <v-toolbar-title>
          {{
            $t('titles.global.newModel', { field: $tc('models.subscription') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="py-0">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex v-if="pay" md6 sm6 xs12 px-1>
              <user-field
                v-model="userId"
                v-validate="'required'"
                :entity-id="id"
                :label="$tc('titles.global.player') + ' (*)'"
                :data-vv-name="$tc('titles.global.player')"
                :error-messages="errors.collect($tc('titles.global.player'))"
                @focus="(e) => e.target.click()"
              />
            </v-flex>
            <v-flex md6 sm6 xs12 px-1>
              <v-autocomplete
                v-model="typeSubscription"
                v-validate="'required'"
                :items="
                  !isAdmin ? types.filter((type) => type.type === 'pay') : types
                "
                :label="
                  $t('action.actions.select', {
                    field: $tc('models.subscription'),
                  }) + ' (*)'
                "
                clearable
                :data-vv-name="$tc('models.subscription')"
                :error-messages="errors.collect($tc('models.subscription'))"
                @focus="(e) => e.target.click()"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button type="cancel" :disabled="loading" @click="cancel" />
        <meta-button type="create" :loading="loading" @click="submit" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UserField from '@/components/widgets/Input/UserField'
import queueToast from '@/helpers/queueToast'

export default {
  name: 'DialogNewSubscription',
  components: { UserField },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    id: {
      type: String,
    },
    email: {
      type: String,
    },
    typeMember: {
      type: String,
    },
    pay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      typeSubscription: '',
      loading: false,
      userId: null,
      day: null,
      duration: null,
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.users.list,
      pagination: (state) => state.users.pagination,
    }),
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
        if (!value) this.clear()
      },
    },
    types() {
      if (this.typeMember === 'entity') {
        return [
          {
            type: 'free',
            days: 15,
            value: 'demo',
            text: this.$t('titles.subscriptions.demo'),
          },
          {
            type: 'free',
            days: 15,
            value: 'guess',
            text: this.$t('titles.subscriptions.guest'),
          },
        ]
      } else {
        return [
          {
            type: 'free',
            days: 15,
            value: 'demo',
            text: this.$t('titles.subscriptions.demo'),
          },
          {
            type: 'free',
            days: 15,
            value: 'guest',
            text: this.$t('titles.subscriptions.guest'),
          },
          {
            type: 'pay',
            days: 365,
            value: 'member',
            text: 'Member',
          },
          {
            type: 'pay',
            days: 365,
            value: 'memberPlus',
            text: 'Member Plus',
          },
          {
            type: 'pay',
            days: 365,
            value: 'formative',
            text: 'Formativa',
          },
        ]
      }
    },
  },
  methods: {
    ...mapActions({
      assignSubscription: 'subscriptions/assignSubscription',
      assignDirectSubscription: 'subscriptions/assignDirectSubscription',
    }),
    submit() {
      if (this.typeSubscription !== '') {
        const data = {
          userIds: [this.userId || this.id],
          sub: this.typeSubscription,
          days: this.types.find((sub) => sub.value === this.typeSubscription)
            .days,
        }
        if (this.typeMember === 'entity') {
          this.assignSubscription(data)
        } else {
          this.assignDirectSubscription(data)
        }
        this.$emit('refresh')
        this.userId = null
        this.sub = null
        this.duration = null
        this.cancel()
      } else {
        queueToast(this.$t('error.error.empty'), 'danger')
      }
    },
    clear() {
      this.typeSubscription = ''
      this.$validator.pause()
      this.nextTick(() => {
        this.$validator.reset()
        this.$validator.resume()
      })
    },
    cancel() {
      this.localValue = false
      this.clear()
    },
  },
}
</script>
